/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetMunicipalQueryResult } from '../../models/get-municipal-query-result';

export interface ApiMunicipalGetMunicipalGet$Params {
  Id?: string;
}

export function apiMunicipalGetMunicipalGet(http: HttpClient, rootUrl: string, params?: ApiMunicipalGetMunicipalGet$Params, context?: HttpContext): Observable<StrictHttpResponse<GetMunicipalQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiMunicipalGetMunicipalGet.PATH, 'get');
  if (params) {
    rb.query('Id', params.Id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetMunicipalQueryResult>;
    })
  );
}

apiMunicipalGetMunicipalGet.PATH = '/api/Municipal/GetMunicipal';
